// Where to send the buyer when the checkout answers `order_completed`: the
// order is already delivered *and* paid for (a repeat click on "pay", a stale
// tab), so the answer is the receipt, the same place a successful payment goes.
//
// Only that type qualifies. A delivered order whose payment never arrived comes
// back as `order_payment_incomplete` and must show an error instead: sending it
// to the thank-you page would report a success that did not happen.
//
// Returns the path to navigate to, or null for any other response.
interface CheckoutResponseLike {
  type?: unknown;
  redirect_path?: unknown;
  success_path?: unknown;
}

export function completedOrderRedirect(data: unknown): string | null {
  if (!data || typeof data !== "object") return null;

  const response = data as CheckoutResponseLike;
  if (response.type !== "order_completed") return null;

  return usablePath(response.redirect_path) ?? usablePath(response.success_path);
}

function usablePath(value: unknown): string | null {
  if (typeof value !== "string") return null;

  return value.trim() ? value : null;
}
